const config = {
    // appUrl : "https:app.webweb.ai",
    appUrl : "http://localhost:3000",
    apiUrl : "https://api.webweb.ai"
    // http://localhost/webweb/websiteEngine
}
  
export default config